<template>
  <div class="home">
    <v-row class="pl-4 ml-2 pr-4 pb-0" style="flex: 0 0 auto">
      <v-col sm="12" md="4" style="flex-basis: auto">
        <div style="display: flex">
          <img
            class="img-responsive"
            src="../assets/images/teambot-connect-logo-vector.png"
          />
        </div>
      </v-col>
      <v-col
        sm="12"
        md="8"
        style="flex-basis: auto; display: flex;"
        class="justify-md-end team-name-container col-sm-12 col-md-8"
      >
        <div class="team-name">
          Recordings
        </div>
      </v-col>
    </v-row>

    <v-container
      style="max-width: 1185px; padding-top: 60px"
      sm="12"
      md="8"
      lg="8"
      offset-lg="2"
      offset-sm="0"
      offset-md="2"
    >
      <div class="video-preview-container" v-if="composition">
        <h2>Past Recordings</h2>
        <v-row>
          <v-col><h3>Event</h3></v-col>
          <v-col><h3>Date</h3></v-col>
          <v-col></v-col>
        </v-row>
        <v-row>
          <v-col>
            {{ composition.event.name }}
          </v-col>
          <v-col>
            {{ new Date(composition.event.start).toDateString() }}
          </v-col>
          <v-col
            ><v-btn color="primary" @click="downloadResource(composition)"
              >Download</v-btn
            ></v-col
          >
        </v-row>
      </div>
    </v-container>

    <snackbar
      :message="snackbar.message"
      :color="snackbar.color"
      :snackbar="snackbar.display"
      :text="snackbar.text"
      :response-buttons="snackbar.buttons"
    ></snackbar>
  </div>
</template>

<script>
import axios from "axios";
import Snackbar from "../components/snackbar";
import { getUser } from "../helpers/api";

export default {
  name: "Recordings",
  components: {
    Snackbar
  },
  data: function() {
    return {
      composition: null,
      snackbar: {
        message: {},
        color: "green",
        display: false,
        text: "",
        responseButtons: false
      },
      user: null
    };
  },
  async mounted() {
    if (this.$route.query.sid) {
      this.getComposition();
    }
  },
  methods: {
    async getComposition() {
      const sid = this.$route.query.sid;
      if (!this.user) this.user = await getUser();
      axios
        .get(`/rest-api/video/recording/download/${sid}/${this.user.id}`)
        .then(response => {
          if (response.data.allowed) {
            this.composition = response.data;
            this.composition.url = `/rest-api/video/recording/${sid}/${this.user.id}`;
          } else {
            this.snackbar.text = "Error: Not Permitted to download this file";
            this.snackbar.color = "red";
            this.snackbar.display = true;
          }
        });
    },
    downloadResource(composition) {
      const fileName =
        composition.event && composition.event.name
          ? composition.event.name
          : "TeambotConnectRecording";
      const a = document.createElement("a");
      a.download = fileName + ".mp4";
      a.href = composition.url;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  }
};
</script>
<style scoped>
.home {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: stretch;
  z-index: 1000;
  width: 100%;
  background: #333333 !important;
  background: -moz-linear-gradient(top, #333333 0%, #121212 100%) !important;
  background: -webkit-linear-gradient(top, #333333 0%, #121212 100%) !important;
  background: linear-gradient(to bottom, #333333 0%, #121212 100%) !important;
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#333333', endColorstr='#121212',GradientType=0 ) !important;
}

.team-name {
  color: white;
  font-size: 22px;
  float: right;
}
.img-responsive {
  max-width: 350px;
  max-height: 43px;
  width: 100%;
}
.video-preview-container {
  position: relative;
  z-index: 1002;
  margin: 0px auto 0 auto;
  padding: 20px 20px 20px 20px;
  background: #333333 !important;
  border-radius: 15px;
  color: white;
}
</style>
